export function getClubs (state) {
	return state.clubs;
}
